import React from 'react';
import { XCircle, AlertOctagon, CheckCircle2, Building2 } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full" data-id="element-281">
      {/* The Problem (Agitation) */}
      <div className="bg-gray-50 py-16 px-4 sm:px-6 lg:px-8" data-id="element-282">
        <div className="max-w-4xl mx-auto" data-id="element-283">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy text-center mb-12" data-id="element-284">
            El trabajo físico en EE.UU. tiene un límite cruel
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-285">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start" data-id="element-286">
              <XCircle className="h-8 w-8 text-brandRed flex-shrink-0 mr-4 mt-1" data-id="element-287" />
              <div data-id="element-288">
                <h3 className="font-bold text-xl text-navy mb-2" data-id="element-289">
                  Tu cuerpo tiene fecha de vencimiento
                </h3>
                <p className="text-gray-600" data-id="element-290">
                  En 10 años más de trabajo de fuerza, la espalda, las rodillas
                  y los hombros pasarán factura.
                </p>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start" data-id="element-291">
              <XCircle className="h-8 w-8 text-brandRed flex-shrink-0 mr-4 mt-1" data-id="element-292" />
              <div data-id="element-293">
                <h3 className="font-bold text-xl text-navy mb-2" data-id="element-294">
                  El salario sube muy poco
                </h3>
                <p className="text-gray-600" data-id="element-295">
                  Puedes ganar $18/hr hoy y $22/hr en 10 años. En IT, empiezas
                  en $22 y en 3 años puedes estar en $45.
                </p>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start" data-id="element-296">
              <XCircle className="h-8 w-8 text-brandRed flex-shrink-0 mr-4 mt-1" data-id="element-297" />
              <div data-id="element-298">
                <h3 className="font-bold text-xl text-navy mb-2" data-id="element-299">
                  Sin credencial americana, eres invisible
                </h3>
                <p className="text-gray-600" data-id="element-300">
                  Tu experiencia y título del país de origen no cuentan aquí.
                </p>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start" data-id="element-301">
              <XCircle className="h-8 w-8 text-brandRed flex-shrink-0 mr-4 mt-1" data-id="element-302" />
              <div data-id="element-303">
                <h3 className="font-bold text-xl text-navy mb-2" data-id="element-304">
                  El tiempo se agota
                </h3>
                <p className="text-gray-600" data-id="element-305">
                  Cada año que pasa sin cambiar es un año más atrapado.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Why past attempts failed */}
      <div className="bg-navy text-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-306">
        <div className="max-w-3xl mx-auto" data-id="element-307">
          <div className="text-center mb-10" data-id="element-308">
            <AlertOctagon className="h-12 w-12 text-brandGold mx-auto mb-4" data-id="element-309" />
            <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-310">
              Por qué lo que has intentado NO funcionó
            </h2>
            <p className="text-xl text-gray-300" data-id="element-311">
              Quizás ya intentaste salir de ahí. Pero:
            </p>
          </div>

          <ul className="space-y-4 mb-10 text-lg" data-id="element-312">
            <li className="flex items-start bg-navy-700 p-4 rounded-lg" data-id="element-313">
              <span className="text-brandRed font-bold mr-3 text-xl" data-id="element-314">🚫</span>
              <span data-id="element-315">
                Los cursos de inglés general te enseñan a pedir café, no a
                resolver tickets técnicos.
              </span>
            </li>
            <li className="flex items-start bg-navy-700 p-4 rounded-lg" data-id="element-316">
              <span className="text-brandRed font-bold mr-3 text-xl" data-id="element-317">🚫</span>
              <span data-id="element-318">
                La universidad tradicional cuesta $40,000 y 4 años que no
                tienes.
              </span>
            </li>
            <li className="flex items-start bg-navy-700 p-4 rounded-lg" data-id="element-319">
              <span className="text-brandRed font-bold mr-3 text-xl" data-id="element-320">🚫</span>
              <span data-id="element-321">
                Aplicar en Indeed sin credencial te pone en una fila de 1,000
                personas donde eres invisible.
              </span>
            </li>
            <li className="flex items-start bg-navy-700 p-4 rounded-lg" data-id="element-322">
              <span className="text-brandRed font-bold mr-3 text-xl" data-id="element-323">🚫</span>
              <span data-id="element-324">
                Esperar a "hablar perfecto" es la trampa que te mantiene en la
                pala por años más.
              </span>
            </li>
          </ul>

          <div className="text-center bg-brandRed p-6 rounded-xl" data-id="element-325">
            <p className="text-2xl font-bold" data-id="element-326">
              El problema no es tu esfuerzo. Es que estás usando el mapa
              equivocado.
            </p>
          </div>
        </div>
      </div>

      {/* Unique Mechanism */}
      <div className="bg-brandBlue text-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-327">
        <div className="max-w-4xl mx-auto text-center" data-id="element-328">
          <h2 className="text-3xl sm:text-4xl font-black mb-8" data-id="element-329">
            Presentando: "El Puente Google-Hispano"
          </h2>

          <p className="text-xl mb-8 leading-relaxed" data-id="element-330">
            Google diseñó certificaciones profesionales específicamente para
            personas{' '}
            <strong className="text-brandGold" data-id="element-331">
              sin experiencia previa y sin título universitario
            </strong>
            .
          </p>

          <div className="bg-white text-navy p-8 rounded-2xl shadow-xl mb-8" data-id="element-332">
            <Building2 className="h-12 w-12 text-brandBlue mx-auto mb-4" data-id="element-333" />
            <p className="text-lg font-medium mb-6" data-id="element-334">
              Estas certificaciones están reconocidas por más de 150 empresas
              líderes en EE.UU. incluyendo:
            </p>
            <div className="flex flex-wrap justify-center gap-4 font-bold text-gray-500" data-id="element-335">
              <span className="bg-gray-100 px-4 py-2 rounded" data-id="element-336">Walmart</span>
              <span className="bg-gray-100 px-4 py-2 rounded" data-id="element-337">Verizon</span>
              <span className="bg-gray-100 px-4 py-2 rounded" data-id="element-338">Ford</span>
              <span className="bg-gray-100 px-4 py-2 rounded" data-id="element-339">
                Bank of America
              </span>
              <span className="bg-gray-100 px-4 py-2 rounded" data-id="element-340">Deloitte</span>
            </div>
          </div>

          <p className="text-2xl font-bold text-brandGold mb-4" data-id="element-341">
            No necesitas ser un genio. No necesitas hablar inglés perfecto.
          </p>
          <p className="text-xl" data-id="element-342">
            Solo necesitas disciplina y el mapa correcto. <br data-id="element-343" />
            <span className="font-bold underline decoration-brandGold decoration-4 underline-offset-4 mt-2 inline-block" data-id="element-344">
              Esta guía es ese mapa.
            </span>
          </p>
        </div>
      </div>
    </section>;
}